export default {"src":"/_next/static/media/toggle_40.bc2dc834.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};